var _path, _path2, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomBellPin = function SvgCustomBellPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.794 3.295a5.586 5.586 0 0 0-7.346 4.674l-.252 2.267-.006.057a8 8 0 0 1-1.074 3.18l-.03.05-.577.963c-.525.874-.787 1.311-.73 1.67a1 1 0 0 0 .345.61c.279.234.789.234 1.808.234h12.136c1.02 0 1.53 0 1.808-.233a1 1 0 0 0 .346-.611c.056-.359-.206-.796-.73-1.67l-.579-.964-.03-.05a7.999 7.999 0 0 1-.96-2.473 5 5 0 0 1-4.129-7.704Zm2.48 1.694a2 2 0 0 0 1.276 2.96 5.568 5.568 0 0 0-1.276-2.96Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17a3 3 0 0 0 6 0H9Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 2.75,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};

export default SvgCustomBellPin;